import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

    getTipoDeliver() {
        return  [
            { clave: 'true', valor: "Entrega" },
            { clave: 'false', valor: "Recibir" },
        ];
    }

    getTipoReport() {
        return  [
            { clave: 'NotaConsolidado', valor: "Nota Consolidado" },
            { clave: 'EstadoArticulos', valor: "Estado Artículos" },
        ];
    }

}